
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-2 -3 12 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ce1126","d":"M-2-3h4v6h-4z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M2-3h8v3H2z"}}),_c('path',{attrs:{"fill":"#009e49","d":"M2 0h8v3H2z"}}),_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-1v1h.5","transform":"rotate(18 0 -1)","fill":"#000"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})])
          )
        }
      }
    